/*
Documentation

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    appointment_templates: [
       { _id: 123, name: 'test 1' },
       { _id: 456, name: 'test 2' },
    ],
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_APPOINTMENT_TEMPLATES:

            return {
                ...state,
                appointment_templates: action.payload,
            }

        default: return state;

    }

}

export default reducer;
